import React, { Component } from "react";
import { connect } from "react-redux";
import { selectFilter } from "../../actions"
import Collapse from '@material-ui/core/Collapse';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatAs, DateFnsFormats } from "../../../../common-client2/src/services/ukgDateTime";

class HistoryPanel extends Component {

  constructor(props) {
    super(props);

    this.state = {
      opened: false
    }
  }


  toggleCollapsable() {
    this.setState({
      opened: 1 - this.state.opened
    });
  }


  generateHistory() {
    let { classes, t, history, managerSettingNames, handleClick = () => { } } = this.props;
    let { opened } = this.state;
    let historySections = [];

    historySections.push(<hr />);
    historySections.push(
      <div className={classes.filterTitle} onClick={() => { this.toggleCollapsable() }}>
        {t('billboard.history')}
        <FontAwesomeIcon icon={opened ? faAngleUp : faAngleDown} style={{ float: "right", marginRight: "10px" }} />
      </div>
    );

    let elements = [];
    for (const item of history) {
      elements.push(
        <div onClick={() => handleClick(item)} key={'historyLog' + item.offerId} className={classes.historyItemContainer}>
          <div className={classes.historyLogFirst}>
            <span className={classes.historyLogName}>{item.employeeName} </span>
            <span>{item.status} </span>
            <span className={classes.historyLogshiftTime}>{managerSettingNames[item.managerSettingId]}</span>
          </div>
          <div className={classes.historyLogDate}>{formatAs(item.dateLogged, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)}</div>
        </div>
      );
    }

    historySections.push(
      <Collapse
        in={opened}
        timeout={{ enter: 750, exit: 750 }}
        style={{ transitionDelay: "250ms" }}
      >
        {elements}
      </Collapse>
    );



    return historySections;
  }


  render() {
    return <div>{this.generateHistory()}</div>;
  }
}

const mapStateToProps = state => {
  return {
    history: state.data.globalHistory,
    managerSettingNames: state.managerSettingNames
  };
};

export default connect(mapStateToProps, { selectFilter })(HistoryPanel);
